import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { equalisations as rules } from 'further-ui/validations';
import { z } from 'zod';

export type EqualisationGeneralCapitalCallsFormValues = z.infer<
  typeof rules.UpdateEqualisationGeneralCapitalCallsFormSchema
>;

type Props = {
  values: EqualisationGeneralCapitalCallsFormValues;
  children: React.ReactNode;
};

const FormWrapper: React.FC<Props> = ({ children, values }) => {
  const formMethods = useForm<EqualisationGeneralCapitalCallsFormValues>({
    shouldFocusError: true,
    resolver: zodResolver(
      rules.UpdateEqualisationGeneralCapitalCallsFormSchema,
    ),
    defaultValues: values,
    criteriaMode: 'all',
    reValidateMode: 'onChange',
  });

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};

export default FormWrapper;
